import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import recruitmentList from "./recruitment/recruitmentList";
import recruitWrite from "./recruitment/recruitWrite";
import recruitView from "./recruitment/recruitView";
import agreement from "./agreement";
import join from "./membership/join";
import login from "./login/login";
import findUserInfo from "./login/findUserInfo";
import userInfo from "./myInfo/userInfo";
import applyInfo from "./myInfo/applyInfo";
import history from "./myInfo/history";
import main from "./main";
import selectData from "./selectData";

const rootReducer = combineReducers({
  recruitmentList,
  recruitWrite,
  recruitView,
  agreement,
  join,
  login,
  findUserInfo,
  userInfo,
  applyInfo,
  history,
  main,
  selectData,
  form: formReducer
});

export default rootReducer;
